import React, { useCallback, useContext, useEffect, useState } from "react";
import Form from "./Form";
import FormActions from "../../../../components/formactions/formactions";
import LeaveRouterPrompt from "../../../../components/leave-confirm-prompt/leave-router-prompt";
import { AppConfig } from "../../../../context/context";
import { USRPIN_FEATURE } from "../../../../utils/constants";
import { useOrgService } from "../../../../services/organizations-service";
import { t } from "i18next";
import pubSub, { EVENTS } from "../../../../config/pubSub";

type IProps = {
  setShowLeavePrompt: (bool: boolean) => void;
};

const AuthenticationTab = (props: IProps) => {
  const { setShowLeavePrompt } = props;
  const [showBtns, setShowBtns] = useState(false);
  const [availableSettings] = useState<any>();
  const [mfa, setMFA] = useState<any>();
  const { config} = useContext(AppConfig);
  const { orgService } = useOrgService();
  const [checkArray, setCheckArray] = useState<string[]>([]);

  /*const initAvs = useCallback(async () => {
    if (!orgService.getOrgAvailableFeatures || !orgService.getOrgAccessCodeConfig) return;
    try {
      const res = await orgService.getOrgAvailableFeatures(config.tenantId);
      const setting = await orgService.getOrgAccessCodeConfig(config.tenantId);
      const pin = res.find((p: any) => p.shortName === USRPIN_FEATURE);
      if(pin) {
        setAvailableSettings([
          { pin: pin.visible, uniqueId: pin.uniqueId, pinLength: setting?.pinCodeLength },
          { test: "test", uniqueId: "test" },
        ]);
      }
    } catch (error) {
      pubSub.publish(EVENTS.ERROR, t("common_error_msg"));
    }
  }, [orgService, config.tenantId]);*/

  const initOIDC = useCallback(async () => {
    if (!orgService.getOrg) return;
    await orgService.getOrg(config.tenantId).then((res) => {
      
      //setOidc(res.oidc ? res.oidc : []);
      setMFA({typeMFA: res.typeMFA, enableMFA: res.enableMFA})
    });
  }, [orgService, config.tenantId]);

  useEffect(() => {
    initOIDC();
  }, [initOIDC]);

  /*useEffect(() => {
    initAvs();
  }, [initAvs]);

  const getPinData = availableSettings?.find((p: any) =>
    p.hasOwnProperty("pin")
  );
  const getEntraId = oidc?.find((p: any) => p.id === "EntraID");*/

  const handleChange = (event: any) => {
    event.preventDefault();
    const el = event.target;
    switch (el.name) {
      /*case "pin":
      case "pinLength":
        const updatedPin = [
          { ...getPinData, [el.name]: el.value },
          ...availableSettings.filter((p: any) => !p.hasOwnProperty("pin")),
        ];
        setCheckArray([...checkArray, el.name]);
        setShowBtns(true);
        setAvailableSettings(updatedPin);
        break;
      case "EntraID":
        const updatedEntraId = [
          { ...getEntraId, status: JSON.parse(el.value) },
          ...oidc.filter((p: any) => p.id !== "EntraID"),
        ];
        setCheckArray([...checkArray, el.name]);
        setShowBtns(true);
        setOidc(updatedEntraId);
        break;*/
      case "MFA":
        const enableMFA = JSON.parse(el.value);
        const typeMFA = enableMFA ? "email": "unknown";
        const updatedMFA = {enableMFA, typeMFA};
        setCheckArray([...checkArray, el.name]);
        setShowBtns(true);
        setMFA(updatedMFA);
        break;
      default:
        break;
    }
  };

  const updateSettings = async () => {
    /*const updatePinData = {
      uniqueId: getPinData.uniqueId,
      shortName: USRPIN_FEATURE,
      visible: JSON.parse(getPinData.pin),
      isFeature: true,
    };*/
    let error: boolean = false;

    /*
    if(checkArray.includes("pin") || checkArray.includes("pinLength")) {
      try {
        await orgService.putOrgAvailableFeatures(config.tenantId, updatePinData);
        if(updatePinData.visible && config.appRegionId !== 'A') {
          await orgService.putOrgAccessCodeConfig(config.tenantId,  {pinCodeLength: parseInt(getPinData.pinLength) });
        }
        initAvs();
        //setShowBtns(false);
        //setShowLeavePrompt(false);
        // pubSub.publish(EVENTS.SUCCESS, t("common_success_updated_msg"));
      } catch (err) {
        error = true;
        //pubSub.publish(EVENTS.ERROR, t("common_error_msg"));
      }
    }*/

    if(checkArray.includes("MFA")) {
      try {
        await orgService.updateOrg({ orgId: config.tenantId, mfa });
        initOIDC();
        setShowBtns(false);
        setShowLeavePrompt(false);
        pubSub.publish(EVENTS.SUCCESS, t("common_success_updated_msg"));
      } catch (err) {
        error = true;
        pubSub.publish(EVENTS.ERROR, t("common_error_msg"));
      }
    }
    /*checkArray.includes("EntraID") && (
      orgService
      .putOrgOidc(config.tenantId, oidc)
      .then(initOIDC)
      /*.then(() => setShowBtns(false))
      .then(() => setShowLeavePrompt(false))
      .then(() =>
        pubSub.publish(EVENTS.SUCCESS, t("common_success_updated_msg"))
      )
      .catch((err) => {
        //setCheckArray([]);
        error = true;
        //pubSub.publish(EVENTS.ERROR, t("common_error_msg"));
      })
    )
    if(error) {
      pubSub.publish(EVENTS.ERROR, t("common_error_msg"));
    } else {
      setCheckArray([]);
      setShowBtns(false);
      setShowLeavePrompt(false);
      pubSub.publish(EVENTS.SUCCESS, t("common_success_updated_msg"))
    }*/
  };
  
  const resetSettings = () => {
    //initAvs()
    initOIDC()
    setCheckArray([]);
    setShowBtns(false)
    setShowLeavePrompt(false);
  };

  return (
    <>
      {mfa && (
        <>
          <LeaveRouterPrompt when={showBtns} />
          <Form
            handleChange={handleChange}
            availableSettings={availableSettings}
            MFAInfo={mfa}
          />
          <FormActions
            showBtns={showBtns}
            resetSettings={resetSettings}
            updateSettings={updateSettings}
            canSubmit={true}
          />
        </>
      )}
    </>
  );
};

export default AuthenticationTab;
